export enum SegmentType {
  CUSTOM = "CUSTOM",
  AI = "AI",
  EASY = "EASY",
}
